export const managementMenu =
    [
        { // 账号管理
            index: 'management-account',
            name: 'manage.account',
            url: '/management/account',
            disable: false,
            auth: "user"
        },
        { // 标准项管理
            index: 'management-standardItem',
            name: 'manage.standardItem',
            url: '/management/standardItem',
            disable: false,
            auth: "dict"
        },
        { // 调试记录
            index: 'management-debugRecord',
            name: 'manage.debugRecord',
            url: '/management/debugRecord',
            disable: false,
            auth: "record"
        },
        { // 权限管理
            index: 'management-authority',
            name: 'manage.authority',
            url: '/management/authority',
            disable: false,
            auth: "auth"
        },
        { // 控制器功能
            index: 'management-panelFunction',
            name: 'manage.panelFunction',
            url: '/management/panelFunction',
            disable: false,
            auth: "function"
        },
        { // 项目存档
            index: 'management-archive',
            name: 'manage.archive',
            url: '/management/archive',
            disable: false,
            auth: "archive"
        },
        { // 产品信息
            index: 'management-product',
            name: 'manage.product',
            url: '/management/product',
            disable: false,
            auth: "product"
        },
        { // 开始调试
            index: 'management-beginDebug',
            name: 'manage.beginDebug',
            url: '/index/1',
            disable: false,
            auth: "begin_menu"
        }
    ]
export const systemMenu =
    [
        {
            index: 'system-unitTest',
            name: 'system.unitTest',
            url: '/system/unitTest',
            disable: false,

        },
        {
            index: 'system-password',
            name: 'system.password',
            url: '/system/password',
            disable: false
        },
        {
            index: 'system-operationMode',
            name: 'system.operationMode',
            url: '/system/operationMode',
            disable: false
        },
        {
            index: 'system-cleaningTreatment',
            name: 'system.cleaningTreatment',
            url: '/system/cleaningTreatment',
            disable: false
        },
        {
            index: 'system-networkController',
            name: 'system.networkController',
            url: '/system/networkController',
            disable: false
        },
        {
            index: 'system-language',
            name: 'system.language',
            url: '/system/language',
            disable: false
        }
    ]
export const installMenu =
    [
        { // 回路部件登记
            index: 'install-registrationOfComponent',
            name: 'install.registrationOfComponent',
            url: '/install/registrationOfComponent',
            disable: false,
            auth: "loop_register"
        },
        { // 部件模拟报警
            index: 'install-analogAlarm',
            name: 'install.analogAlarm',
            url: '/install/analogAlarm',
            disable: false,
            auth: "virtual_alarm"
        },
        { // 定点编织
            index: 'install-fixedPointAddressing',
            name: 'install.fixedPointAddressing',
            url: '/install/fixedPointAddressing',
            disable: false,
            auth: "position_address"
        },
        { // 远程升级
            index: 'install-remoteUpgrade',
            name: 'install.remoteUpgrade',
            url: '/install/remoteUpgrade',
            disable: false,
            auth: "upgrade"
        }
    ]
export const settingMenu =
    [
        { // 设置打印机
            index: 'setting-printer',
            name: 'setting.printer',
            url: '/setting/printer',
            disable: false,
            auth: "printer"
        },
        { // 设置手动启停设备
            index: 'setting-manualStartStop',
            name: 'setting.manualStartStop',
            url: '/setting/manualStartStop',
            disable: false,
            auth: "manual_start_stop"
        },
        { // 设置部件屏蔽
            index: 'setting-componentShielding',
            name: 'setting.componentShielding',
            url: '/setting/componentShielding',
            disable: false,
            auth: "shield"
        }
    ]
export const testMenu =
    [
        { // 探测器模拟曲线
            index: 'test-simulationCurve',
            name: 'test.simulationCurve',
            url: '/test/simulationCurve',
            disable: false,
            auth: "analog"
        },
        { // 回路状态浏览
            index: 'test-statusBrowsing',
            name: 'test.statusBrowsing',
            url: '/test/statusBrowsing',
            disable: false,
            auth: "loop_signal"
        },
        { // 现场部件数据查询
            index: 'test-dataQuery',
            name: 'test.dataQuery',
            url: '/test/dataQuery',
            disable: false,
            auth: "device_data"
        },
        { // 现场状态信号值
            index: 'test-statusSignalValue',
            name: 'test.statusSignalValue',
            url: '/test/statusSignalValue',
            disable: false,
            auth: "background_elec"
        },
        { // 现场部件类型状态
            index: 'test-typeStatus',
            name: 'test.typeStatus',
            url: '/test/typeStatus',
            disable: false,
            auth: "type_stat"
        },
        /*{
            index: 'test-authorization',
            name: 'test.authorization',
            url: '/test/authorization'
        },*/
        { // 工作电压
            index: 'test-operatingVoltage',
            name: 'test.operatingVoltage',
            url: '/test/operatingVoltage',
            disable: false,
            auth: "voltage"
        }
    ]
export const queryMenu =
    [
        { // 注册地址
            index: 'query-registeredAddress',
            name: 'query.registeredAddress',
            url: '/query/registeredAddress',
            disable: false,
            auth: "register_addr"
        },
        { // 联动编程
            index: 'query-linkageProgramming',
            name: 'query.linkageProgramming',
            url: '/query/linkageProgramming',
            disable: false,
            auth: "program"
        },
        { // 注释信息
            index: 'query-annotationInformation',
            name: 'query.annotationInformation',
            url: '/query/annotationInformation',
            disable: false,
            auth: "descr"
        },
        { // 历史记录
            index: 'query-historyRecord',
            name: 'query.historyRecord',
            url: '/query/historyRecord',
            disable: false,
            auth: "histroy"
        },
        { // 单元班卡
            index: 'query-unitBoardInformation',
            name: 'query.unitBoardInformation',
            url: '/query/unitBoardInformation',
            disable: false,
            auth: "board"
        },
        { // 系统单元配置
            index: 'query-unitConfiguration',
            name: 'query.unitConfiguration',
            url: '/query/unitConfiguration',
            disable: false,
            auth: "sys_config"
        },
        { // 组网配置
            index: 'query-networkConfiguration',
            name: 'query.networkConfiguration',
            url: '/query/networkConfiguration',
            disable: false,
            auth: "network_setting"
        },
        { // 授权管理
            index: 'query-authorizationManagement',
            name: 'query.authorizationManagement',
            url: '/query/authorizationManagement',
            disable: false,
            auth: "grant"
        }
    ]
export const monitorMenu =
    [
        /*{
            index: 'monitor-1',
            name: '系统单元测试',
            url: '/monitor/account'
        },
        {
            index: 'monitor-2',
            name: '设置密码',
            url: '/monitor/account'
        },
        {
            index: 'monitor-3',
            name: '设置运行模式',
            url: '/monitor/account'
        },
        {
            index: 'monitor-4',
            name: '清除处理',
            url: '/monitor/account'
        },
        {
            index: 'monitor-5',
            name: '设置组网控制器',
            url: '/monitor/account'
        },
        {
            index: 'monitor-6',
            name: '设置语言',
            url: '/monitor/account'
        }*/
    ]
export const siderBarList = [
    { // 监控
        index: "monitor",
        icon: "iconjiankongshebeiguanli",
        name: "sidebar.monitor",
        auth: "monitor",
        setDisable:false,
        disabledActive: true,
        childrenMenu: "",
    },
    { // 查询
        index: "query",
        icon: "iconchaxun",
        name: "sidebar.query",
        auth: "query",
        setDisable:false,
        disabledActive: true,
        childrenMenu: queryMenu,

    },
    { //  测试
        index: "test",
        icon: "iconceshi",
        name: "sidebar.test",
        auth: "test",
        setDisable:false,
        disabledActive: true,
        childrenMenu: testMenu,

    },
    { // 设置
        index: "setting",
        icon: "iconshezhi",
        name: "sidebar.setting",
        auth: "setting",
        setDisable:false,
        disabledActive: true,
        childrenMenu: settingMenu,

    },
    { // 安装
        index: "install",
        icon: "iconanzhuang",
        name: "sidebar.install",
        auth: "setup",
        setDisable:false,
        disabledActive: true,
        childrenMenu: installMenu,
    },
    // { // 系统
    //     index: "system",
    //     icon: "iconxitong",
    //     auth: "system",
    //     disabledActive: true
    // },
    { // 管理
        index: "management",
        icon: "iconjichuguanli",
        name: "sidebar.manage",
        auth: "management",
        setDisable:false,
        disabledActive: false,
        childrenMenu: managementMenu,
    },
]
